module.exports = __webpack_public_path__ + "static/img/bottom_bg.5de63af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/class/bottom_bg.png
// module id = ls3b
// module chunks = 1